import type { Entity } from '@onefootprint/request-types/dashboard';
import { CdoToAllDisMap, CollectedKycDataOption, DocumentDI, InvestorProfileDI } from '@onefootprint/types';

export const hasEntityUsLegalStatus = (entity: Entity) => {
  const legalStatusDIs = CdoToAllDisMap[CollectedKycDataOption.usLegalStatus];
  // @ts-expect-error migrate this to the new CDO
  return entity.data.some(attr => legalStatusDIs.includes(attr.identifier));
};

export const hasEntityNationality = (entity: Entity) => {
  return entity.data.some(attr => attr.identifier === 'id.nationality');
};

export const hasEntityInvestorProfile = (entity: Entity) => {
  const values = Object.values(InvestorProfileDI);
  return values.some(investorProfileDi => entity.data.some(attribute => attribute.identifier === investorProfileDi));
};

export const hasEntityBankAccounts = (entity: Entity) => {
  return entity.data.some(attr => attr.identifier.startsWith('bank'));
};

export const hasEntityCards = (entity: Entity) => {
  return entity.data.some(attr => attr.identifier.startsWith('card'));
};

export const hasEntityCustomData = (entity: Entity) => {
  return entity.data.some(attr => attr.identifier.startsWith('custom'));
};

export const hasEntityUsTaxId = (entity: Entity) => {
  return entity.data.some(attr => attr.identifier === 'id.us_tax_id');
};

export const hasEntityDocuments = (entity: Entity) => {
  const values = Object.values(DocumentDI);
  return values.some(documentDI =>
    entity.data.some(
      attribute =>
        attribute.identifier === documentDI &&
        // this is a little bit hacky for now, but finra compliance belongs to the investor profile CDO in theory
        // however in the backend, is part of the documentCDO
        documentDI !== 'document.finra_compliance_letter',
    ),
  );
};
